import React, { useState } from 'react';

export default function ContattiPage() {
  const [form, setForm] = useState({ nome: '', cognome: '', email: '', messaggio: '' });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await new Promise(r => setTimeout(r, 1000));
    setSent(true);
    setLoading(false);
  };

  return (
    <div style={{ background: '#F8F8F6', minHeight: '100vh' }}>
      <style>{`
        .contatti-input {
          width: 100%;
          padding: 11px 14px;
          font-size: 15px;
          border: 1px solid #E0DED6;
          border-radius: 8px;
          background: white;
          color: #1a1a1a;
          outline: none;
          transition: border-color 0.15s, box-shadow 0.15s;
          font-family: inherit;
          box-sizing: border-box;
        }
        .contatti-input:focus {
          border-color: #1D9E75;
          box-shadow: 0 0 0 3px rgba(29,158,117,0.1);
        }
        .contatti-input::placeholder { color: #B0AEA8; }
        .contatti-label {
          display: block;
          font-size: 13px;
          font-weight: 500;
          color: #3B3B35;
          margin-bottom: 6px;
        }
        .contatti-field { display: flex; flex-direction: column; }
        .contatti-btn {
          width: 100%;
          padding: 13px;
          background: #1D9E75;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          transition: opacity 0.15s;
          font-family: inherit;
        }
        .contatti-btn:hover { opacity: 0.88; }
        .contatti-btn:disabled { opacity: 0.6; cursor: not-allowed; }
        .info-card {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          padding: 20px;
          background: white;
          border-radius: 10px;
          border: 1px solid #E0DED6;
        }
        .info-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #EAF3DE;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 18px;
        }
        .contatti-grid {
          max-width: 960px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 380px;
          gap: 40px;
          align-items: start;
        }
        @media (max-width: 768px) {
          .contatti-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      {/* Hero */}
      <section style={{ background: 'white', borderBottom: '1px solid #E0DED6', padding: '56px 24px 48px', textAlign: 'center' }}>
        <div style={{ maxWidth: 580, margin: '0 auto' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#EAF3DE', color: '#3B6D11', borderRadius: 20, padding: '4px 14px', fontSize: 12, fontWeight: 500, marginBottom: 20 }}>
            Siamo qui per aiutarti
          </div>
          <h1 style={{ fontSize: 38, fontWeight: 500, color: '#1a1a1a', lineHeight: 1.2, marginBottom: 16 }}>
            Contattaci
          </h1>
          <p style={{ fontSize: 16, color: '#5C5B55', lineHeight: 1.7, margin: 0 }}>
            Hai domande sulla certificazione ESG? Compila il modulo e ti risponderemo entro 24 ore.
          </p>
        </div>
      </section>

      {/* Content */}
      <section style={{ padding: '56px 24px 72px' }}>
        <div className="contatti-grid">

          {/* Form */}
          <div style={{ background: 'white', borderRadius: 12, border: '1px solid #E0DED6', padding: '40px' }}>
            {sent ? (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#EAF3DE', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: 28 }}>✓</div>
                <h3 style={{ fontSize: 20, fontWeight: 500, color: '#1a1a1a', marginBottom: 10 }}>Messaggio inviato!</h3>
                <p style={{ fontSize: 15, color: '#5C5B55', lineHeight: 1.7, marginBottom: 28 }}>
                  Grazie per averci contattato. Ti risponderemo entro 24 ore all'indirizzo <strong>{form.email}</strong>.
                </p>
                <button
                  onClick={() => { setSent(false); setForm({ nome: '', cognome: '', email: '', messaggio: '' }); }}
                  style={{ fontSize: 14, color: '#1D9E75', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', fontFamily: 'inherit' }}
                >
                  Invia un altro messaggio
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <div className="contatti-field">
                    <label className="contatti-label">Nome *</label>
                    <input className="contatti-input" type="text" placeholder="Mario" value={form.nome} onChange={set('nome')} required />
                  </div>
                  <div className="contatti-field">
                    <label className="contatti-label">Cognome *</label>
                    <input className="contatti-input" type="text" placeholder="Rossi" value={form.cognome} onChange={set('cognome')} required />
                  </div>
                </div>
                <div className="contatti-field">
                  <label className="contatti-label">Email *</label>
                  <input className="contatti-input" type="email" placeholder="mario.rossi@azienda.it" value={form.email} onChange={set('email')} required />
                </div>
                <div className="contatti-field">
                  <label className="contatti-label">Messaggio *</label>
                  <textarea
                    className="contatti-input"
                    placeholder="Descrivi la tua richiesta..."
                    rows={6}
                    value={form.messaggio}
                    onChange={set('messaggio')}
                    required
                    style={{ resize: 'vertical', minHeight: 140 }}
                  />
                </div>
                <button type="submit" className="contatti-btn" disabled={loading}>
                  {loading ? 'Invio in corso...' : 'Invia messaggio →'}
                </button>
                <p style={{ fontSize: 12, color: '#9B9A92', margin: 0, textAlign: 'center' }}>
                  I tuoi dati sono trattati nel rispetto del GDPR. Non verranno condivisi con terze parti.
                </p>
              </form>
            )}
          </div>

          {/* Info sidebar */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="info-card">
              <div className="info-icon">📧</div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 4 }}>Email</div>
                <div style={{ fontSize: 14, color: '#5C5B55' }}>info@esgcert.it</div>
                <div style={{ fontSize: 12, color: '#9B9A92', marginTop: 2 }}>Risposta entro 24 ore</div>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">⏱</div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 4 }}>Tempi di risposta</div>
                <div style={{ fontSize: 14, color: '#5C5B55' }}>Lun–Ven, 9:00–18:00</div>
                <div style={{ fontSize: 12, color: '#9B9A92', marginTop: 2 }}>Entro 1 giorno lavorativo</div>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">📋</div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 4 }}>Consulenza gratuita</div>
                <div style={{ fontSize: 14, color: '#5C5B55' }}>Prima valutazione sempre gratuita e senza impegno.</div>
              </div>
            </div>

            <div style={{ background: '#1D9E75', borderRadius: 10, padding: '24px 20px', marginTop: 8 }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: 'white', marginBottom: 8 }}>Pronto a iniziare?</div>
              <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.8)', lineHeight: 1.6, marginBottom: 16 }}>
                Registrati gratuitamente e avvia la tua certificazione ESG in pochi minuti.
              </p>
              <a href="/register" style={{ display: 'block', textAlign: 'center', background: 'white', color: '#1D9E75', fontWeight: 600, fontSize: 13, padding: '10px', borderRadius: 7, textDecoration: 'none' }}>
                Registrati gratis →
              </a>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
